<template>
  <div class="sf-plan-container">
    <!-- ====== 顶部：筛选区域 ====== -->
    <div class="filter-section">
      <el-form :inline="true" size="small" class="filter-form" :model="filterForm">
        <el-form-item label="房屋地址">
          <el-input
            v-model="filterForm.房屋地址"
            placeholder="请输入房屋地址"
            clearable
            style="width:220px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            v-model="filterForm.状态"
            placeholder="请选择状态"
            clearable
            style="width:140px"
            @change="handleSearch"
          >
            <el-option label="待付" value="待付" />
            <el-option label="已付" value="已付" />
            <el-option label="已中止" value="已中止" />
            <el-option label="待审核" value="待审核" />
          </el-select>
        </el-form-item>

        <el-form-item label="预计付款日期">
          <el-date-picker
            v-model="filterForm.预计付款日期范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item label="实际付款日期">
          <el-date-picker
            v-model="filterForm.实际付款日期范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- ====== 中间：按钮区域 ====== -->
    <div class="button-section">
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-money"
        :disabled="!canOperate"
        @click="openPaymentDialog"
      >
        付款
      </el-button>
      <el-button
        type="info"
        size="medium"
        icon="el-icon-view"
        :disabled="!canOperate"
        @click="openViewDialog"
      >
        查看
      </el-button>
      <el-button
        type="success"
        size="medium"
        icon="el-icon-house"
        :disabled="!canOperate"
        @click="openHouseDetailDialog"
      >
        查看房源信息
      </el-button>
        <el-button
        type="primary"
        size="medium"
        icon="el-icon-edit"
        style="background-color: #67c23a; border-color: #67c23a; color: #fff;"
        :disabled="!canOperate"
        @click="openBankInfoDialog"
      >
        修改开户行
      </el-button>
    </div>

    <!-- ====== 下方：表格区域 ====== -->
    <div class="table-section">
      <el-table
        ref="tableRef"
        :data="tableData"
        border
        stripe
        highlight-current-row
        v-loading="loading"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
          @row-dblclick="handleRowDblclick"
        style="width: 100%"
        max-height="550"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="房东" label="房东" width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="房屋地址" label="房屋地址" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="状态" label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="getStatusType(row.状态)" size="small">
              {{ row.状态 || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="合同起始日" label="合同起始日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同起始日) }}
          </template>
        </el-table-column>
        <el-table-column prop="合同到期日" label="合同到期日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同到期日) }}
          </template>
        </el-table-column>
        <el-table-column prop="付款日期" label="预计付款日期" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.付款日期) }}
          </template>
        </el-table-column>
        <el-table-column prop="付款金额" label="预计付款金额" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row.付款金额 ? `¥${row.付款金额}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="支付户名" label="支付户名" width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="银行卡号" label="银行卡号" width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="开户行" label="开户行" width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="距离付款天数" label="距离付款还有*天" width="140" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.距离付款天数 !== null && row.距离付款天数 !== undefined ? row.距离付款天数 : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="实际付款时间" label="实际付款时间" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.实际付款时间) }}
          </template>
        </el-table-column>
        <el-table-column prop="实际付款金额" label="实际付款金额" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row.实际付款金额 ? `¥${row.实际付款金额}` : '-' }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          background
        />
      </div>
    </div>

    <!-- ====== 付款弹窗 ====== -->
    <PaymentDialog
      :visible.sync="paymentDialogVisible"
      :row-data="selectedRows.length === 1 ? selectedRows[0] : null"
      @refresh="refresh"
    />

    <!-- ====== 查看弹窗 ====== -->
    <ViewDialog
      :visible.sync="viewDialogVisible"
      :row-data="selectedRows.length === 1 ? selectedRows[0] : null"
    />

    <!-- ====== 房源详情弹窗 ====== -->
    <HouseDetailDialog
      :visible.sync="houseDetailDialogVisible"
      :house-id="selectedRows.length === 1 ? selectedRows[0].房源ID : null"
    />

    <!-- ====== 修改开户行弹窗 ====== -->
  <!-- ====== 修改开户行弹窗 ====== -->
<el-dialog
  title="修改开户行"
  :visible.sync="bankInfoDialog.visible"
  width="600px"
  :close-on-click-modal="false"
  @close="resetBankInfoForm"
  class="bank-info-dialog"
  top="15vh"
>
  <el-form :model="bankInfoForm" label-width="140px" size="small">
    <!-- 第1行：房屋地址 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="房屋地址">
          <el-input v-model="bankInfoForm.房屋地址" disabled />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 第2行：预计付款日期 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="预计付款日期">
          <el-date-picker
            v-model="bankInfoForm.付款日期"
            type="date"
            placeholder="请选择预计付款日期"
            value-format="timestamp"
            disabled
            style="width:100%"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 第3行：预计付款金额 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="预计付款金额">
          <el-input-number
            v-model="bankInfoForm.付款金额"
            :min="0"
            :precision="2"
            :step="100"
            disabled
            style="width:100%"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 第4行：第几次付款 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="第几次付款">
          <el-input-number
            v-model="bankInfoForm.第几次付款"
            :min="1"
            :step="1"
            disabled
            style="width:100%"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 第5行：支付户名 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="支付户名">
          <el-input v-model="bankInfoForm.支付户名" placeholder="请输入支付户名" />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 第6行：开户行 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="开户行">
          <el-input v-model="bankInfoForm.开户行" placeholder="请输入开户行" />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 第7行：银行卡号 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="银行卡号">
          <el-input v-model="bankInfoForm.银行卡号" placeholder="请输入银行卡号" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>

  <span slot="footer">
    <el-button @click="bankInfoDialog.visible = false">取消</el-button>
    <el-button type="primary" @click="handleBankInfoSubmit" :loading="bankInfoDialog.submitting">确认</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import { sfPlanApi } from '@/api/付款/sfPlanApi'
import PaymentDialog from './component/PaymentDialog.vue'
import ViewDialog from './component/ViewDialog.vue'
import HouseDetailDialog from './component/HouseDetailDialog.vue'

export default {
  name: 'MoneySfPlan',

  components: {
    PaymentDialog,
    ViewDialog,
    HouseDetailDialog
  },

  data() {
    return {
      filterForm: {
        房屋地址: '',
        状态: '待付',
        预计付款日期范围: [],
        实际付款日期范围: []
      },
      tableData: [],
      loading: false,
      selectedRows: [],
      pageInfo: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      paymentDialogVisible: false,
      viewDialogVisible: false,
      houseDetailDialogVisible: false,
       // ====== 修改开户行弹窗 ======
      bankInfoDialog: {
        visible: false,
        submitting: false,
        rowData: null
      },
      bankInfoForm: {
        房屋地址: '',
        付款日期: null,
        付款金额: null,
        第几次付款: null,
        支付户名: '',
        开户行: '',
        银行卡号: ''
      }
    }
  },

  computed: {
    canOperate() {
      return this.selectedRows.length === 1
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      this.loadData()
    },

   mapFields(data) {
  if (!data) return {}

  const fieldMap = {
    'id': 'id',
    '房源ID': '房源ID',
    '状态': '状态',
    '付款日期': '付款日期',      // 对应预计付款日期
    '付款金额': '付款金额',      // 对应预计付款金额
    '房屋地址': '房屋地址',
    '第几次付款': '第几次付款',
    '银行卡号': '银行卡号',
    '备注': '备注',
    '房东': '房东',
    '合同起始日': '合同起始日',
    '合同到期日': '合同到期日',
    '开户行': '开户行',
    '支付户名': '支付户名',
    '实际付款时间': '实际付款时间',
    '实际付款金额': '实际付款金额',
    '退回原因': '退回原因'  // 新增
  }

  const result = {}
  for (const [backendKey, frontendKey] of Object.entries(fieldMap)) {
    if (data.hasOwnProperty(backendKey)) {
      result[frontendKey] = data[backendKey]
    }
  }

  // 时间戳转为毫秒级
  const timestampFields = ['付款日期', '合同起始日', '合同到期日', '实际付款时间']
  timestampFields.forEach(field => {
    if (result[field] !== undefined && result[field] !== null && result[field] !== '') {
      const str = String(result[field])
      if (str.length === 10) {
        result[field] = result[field] * 1000
      }
    }
  })

  // 计算距离付款天数
  if (result.状态 === '待付' && result.付款日期) {
    const now = new Date().getTime()
    const diffDays = Math.ceil((result.付款日期 - now) / (1000 * 60 * 60 * 24))
    result.距离付款天数 = diffDays
  } else {
    result.距离付款天数 = null
  }

  return result
},

    loadData() {
      this.loading = true

      const params = {
        pageIndex: this.pageInfo.pageIndex - 1,
        pageSize: this.pageInfo.pageSize
      }

      if (this.filterForm.房屋地址) {
        params.房屋地址 = this.filterForm.房屋地址
      }
      if (this.filterForm.状态) {
        params.状态 = this.filterForm.状态
      }
      if (this.filterForm.预计付款日期范围 && this.filterForm.预计付款日期范围.length === 2) {
        const [start, end] = this.filterForm.预计付款日期范围
        params.付款时间_start = Math.floor(start / 1000)
        params.付款时间_end = Math.floor(end / 1000)
      }
      if (this.filterForm.实际付款日期范围 && this.filterForm.实际付款日期范围.length === 2) {
        const [start, end] = this.filterForm.实际付款日期范围
        params.实际付款时间_start = Math.floor(start / 1000)
        params.实际付款时间_end = Math.floor(end / 1000)
      }

      console.log('查询收房付款计划参数===', params)

      sfPlanApi.select(params).then((res) => {
        console.log('返回数据===', res)

        if (res.code === 200) {
          const rawList = res.data?.list || []
          this.tableData = rawList.map(item => this.mapFields(item))
          // 从后端返回更新 pageInfo
          if (res.data?.pageIndex !== undefined) {
            // 后端返回的是从0开始的页码，需要+1
            this.pageInfo.pageIndex = res.data.pageIndex + 1
          }
          if (res.data?.total !== undefined) {
            this.pageInfo.total = res.data.total
          }
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch((err) => {
        console.error('请求失败===', err)
        this.$message.error('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },

    handleSearch() {
      this.pageInfo.pageIndex = 1
      this.loadData()
    },

    resetSearch() {
      this.filterForm = {
        房屋地址: '',
        状态: '待付',
        预计付款日期范围: [],
        实际付款日期范围: []
      }
      this.handleSearch()
    },

    handleSizeChange(size) {
      this.pageInfo.pageSize = size
      this.pageInfo.pageIndex = 1
      this.loadData()
    },

    handleCurrentChange(page) {
      this.pageInfo.pageIndex = page
      this.loadData()
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection
    },

    handleRowClick(row) {
      this.$refs.tableRef.toggleRowSelection(row)
    },

    openPaymentDialog() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }
      this.paymentDialogVisible = true
    },

    openViewDialog() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }
      this.viewDialogVisible = true
    },

    openHouseDetailDialog() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }
      const row = this.selectedRows[0]
      if (!row.房源ID) {
        this.$message.warning('该记录没有关联的房源ID')
        return
      }
      this.houseDetailDialogVisible = true
    },

    getStatusType(status) {
      const map = {
        '待付': 'danger',
        '已付': 'success',
        '已中止': 'info',
        '待审核': 'warning'
      }
      return map[status] || 'info'
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      let ts = timestamp
      const str = String(ts)
      if (str.length === 10) {
        ts = ts * 1000
      }
      const date = new Date(ts)
      if (isNaN(date.getTime())) {
        return '-'
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    refresh() {
      this.loadData()
    },
    // ====== 双击行 - 打开查看弹窗 ======
handleRowDblclick(row) {
  // 先选中该行
  this.$refs.tableRef.toggleRowSelection(row)
  // 更新选中行
  this.selectedRows = [row]
  // 打开查看弹窗
  this.viewDialogVisible = true
},
 // ====== 打开修改开户行弹窗 ======
   // ====== 打开修改开户行弹窗 ======
openBankInfoDialog() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }

  const row = this.selectedRows[0]

  console.log('打开修改开户行弹窗，行数据:', row)  // 调试日志

  this.bankInfoDialog.rowData = row
  this.bankInfoForm = {
    房屋地址: row.房屋地址 || '',
    付款日期: row.付款日期 || null,
    付款金额: row.付款金额 !== undefined && row.付款金额 !== null ? row.付款金额 : null,
    第几次付款: row.第几次付款 !== undefined && row.第几次付款 !== null ? row.第几次付款 : null,
    支付户名: row.支付户名 || '',
    开户行: row.开户行 || '',
    银行卡号: row.银行卡号 || ''
  }

  console.log('bankInfoForm 赋值后:', this.bankInfoForm)  // 调试日志

  this.bankInfoDialog.visible = true
},

    // ====== 重置修改开户行表单 ======
    resetBankInfoForm() {
      this.bankInfoDialog.submitting = false
      this.bankInfoDialog.rowData = null
      this.bankInfoForm = {
        房屋地址: '',
        付款日期: null,
        付款金额: null,
        第几次付款: null,
        支付户名: '',
        开户行: '',
        银行卡号: ''
      }
    },

    // ====== 提交修改开户行 ======
    handleBankInfoSubmit() {
      const row = this.bankInfoDialog.rowData
      const hasChange =
        this.bankInfoForm.支付户名 !== (row.支付户名 || '') ||
        this.bankInfoForm.开户行 !== (row.开户行 || '') ||
        this.bankInfoForm.银行卡号 !== (row.银行卡号 || '')

      if (!hasChange) {
        this.$message.warning('未检测到任何修改')
        return
      }

      this.$confirm(
        `确认修改该付款计划的开户信息吗？`,
        '修改确认',
        {
          type: 'warning',
          confirmButtonText: '确认修改',
          cancelButtonText: '取消'
        }
      ).then(async () => {
        this.bankInfoDialog.submitting = true

        try {
          const updateParams = {
            id: row.id,
            支付户名: this.bankInfoForm.支付户名 || '',
            开户行: this.bankInfoForm.开户行 || '',
            银行卡号: this.bankInfoForm.银行卡号 || ''
          }

          console.log('修改开户行参数===', updateParams)

          const res = await sfPlanApi.update(updateParams)
          console.log('修改开户行返回===', res)

          if (res.code === 200) {
            this.$message.success('修改成功')
            this.bankInfoDialog.visible = false
            this.loadData()
          } else {
            this.$message.error(res.message || '修改失败')
          }
        } catch (error) {
          console.error('修改失败:', error)
          this.$message.error(error.message || '修改失败，请稍后重试')
        } finally {
          this.bankInfoDialog.submitting = false
        }
      }).catch(() => {
        this.$message.info('已取消修改')
      })
    }
  }
  
}
</script>

<style scoped>
.sf-plan-container {
  padding: 20px;
  background: #f0f2f5;
  min-height: 100vh;
}

.filter-section {
  background: #fff;
  padding: 20px 20px 0 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.filter-form {
  margin-bottom: 0;
}

.button-section {
  background: #fff;
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.button-section .el-button {
  margin-bottom: 4px;
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.pagination-section {
  margin-top: 16px;
  text-align: right;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .sf-plan-container {
    padding: 10px;
  }

  .filter-form .el-form-item {
    display: block;
    margin-right: 0;
  }

  .button-section .el-button {
    margin-bottom: 8px;
  }
}
</style>